// extracted by mini-css-extract-plugin
export default {"button":"SavePanel_button__DdbCT","smallButton":"SavePanel_smallButton__9EGLH","icon":"SavePanel_icon__OKQPD"};